import { Component, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';

@Component({
  selector: 'rmt-card',
  templateUrl: 'rmt-card.html'
})
export class RmtCardComponent {
  @Input() button: boolean = true;
  @Input() buttons;
  @Input() subText;
  @Input() customId:string='';
  @Input() clickable: boolean = false;
  @Input() isPrepaidCardInProcess: boolean = false;
  @Input() isPrepaidCardToBeActive: boolean = false;
  @Input() allCardsActive: boolean = false;
  @Output() clickButton = new EventEmitter<number>();
  @ViewChild('rmtCardBtn', {read: ElementRef}) rmtCardBtn: ElementRef;

  constructor() {
  }

  processButton(ev, i) {
    ev.stopPropagation(); // if there is a click listener on the card itself    
    this.clickButton.emit(i);
  }

  public getRmtCardBtn(): ElementRef {
    return this.rmtCardBtn;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-card/rmt-card.ts